import { createSvgIcon } from "@mui/material";

export const DescriptionIcon = createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 283.46 283.46" fill="currentColor">
        <g>
            <path d="M207.91,109.15h-0.01c0,0,0,0,0,0c-16.35-16.48-33.79-34.13-50.14-50.61l-5.82,0.03v0H96.55
                c-11.58,0-21,9.42-21,21v124.36c0,11.58,9.42,21,21,21h90.36c11.58,0,21-9.42,21-21V109.15z M186.91,206.93H96.55
                c-1.63,0-3-1.37-3-3V79.56c0-1.63,1.37-3,3-3h53.71c0,13.28,0,26.54,0,39.84c13.22,0,26.43,0,39.65,0v87.52
                C189.91,205.55,188.54,206.93,186.91,206.93z"/>
            <rect x="108.22" y="140.29" width="66.89" height="18"/>
            <rect x="108.22" y="173.92" width="66.89" height="18"/>
        </g>
    </svg>,
    'DescriptionIcon'
)
